import { Control, Controller, FieldValues } from "react-hook-form";
import * as S from "./style"
import { InputHTMLAttributes } from 'react';

import { NumericFormat } from "react-number-format"

const PercentageInpt = NumericFormat as any

interface ICurrencyInput extends InputHTMLAttributes<HTMLInputElement> {
    label?: string;
    id: string;
    control: Control<FieldValues, object>;
    name: string;
    type?: string;
    error?: any;
}

const PercentageInput = ({
    label,
    id,
    control,
    name,
    type = "text",
    error,
    ...props
}: ICurrencyInput) => {
    return (
        <S.CurrencyInputContainer>
            {
                label && (
                    <S.StyledCurrencyLabel htmlFor={id}>{label}</S.StyledCurrencyLabel>
                )
            }
            <Controller
                name={name}
                control={control}
                render={({ field }) => (
                    <PercentageInpt
                        customInput={S.StyledCurrencyInput}
                        suffix="%"
                        decimalScale={0}
                        allowNegative={false}
                        isAllowed={(values: any) => {
                            const { value } = values;
                            return value < 100.1
                        }}
                        id={id}
                        error={error}
                        name={name}
                        placeholder={props.placeholder}
                        value={field.value}
                        onChange={field.onChange}
                        {...props}
                    />
                )}
            />
            {
                error && (
                    <S.StyledCurrencyError>
                        {error}
                    </S.StyledCurrencyError>
                )
            }
        </S.CurrencyInputContainer>
    )
}

export default PercentageInput